import { useEffect, useRef } from 'react';

import { useEventHandler } from '../../../../hooks/useEventHandler';
import { usePublicWebsocketService } from '../usePublicWebsocketService';

export const useSubscribeToPublicWebsocketEvent = <T = unknown>(
  channelName: string | undefined,
  eventName: string,
  callback: (data: T) => void,
) => {
  const publicWebsocketService = usePublicWebsocketService();
  const unsubscribeRef = useRef<() => void | undefined>(undefined);
  const handlePublicWebsocketEvent = useEventHandler(callback);

  useEffect(() => {
    if (channelName) {
      unsubscribeRef.current = publicWebsocketService.subscribeToEvent<T>(
        channelName,
        eventName,
        handlePublicWebsocketEvent,
      );
    }
    return unsubscribeRef.current;
  }, [channelName, eventName, handlePublicWebsocketEvent]);
};
